import React from "react";
import { Dropdown } from "react-bootstrap";
import { useSelector } from "react-redux";
import { selectUsedTheme } from "_redux/slices/timeline/theme";
import { Spacing } from "_styles";
import { timelineRoles } from "../timeline-constants";

const buildOptions = () => {
  const base = Array.isArray(timelineRoles)
    ? timelineRoles.map((role) => ({
      value: role?.value ?? role,
      label: role?.label ?? role?.value ?? role ?? "",
    }))
    : [];
  return [{ value: "all", label: "All" }, ...base];
};

const EmployeeRoleFilter = ({ value = "all", onChange }) => {
  const usedTheme = useSelector(selectUsedTheme);
  const options = buildOptions();

  const renderLabel = (val) => {
    const match = options.find((opt) => opt.value === val);
    return match?.label ?? "Select Role";
  };

  return (
    <Dropdown onSelect={(next) => onChange?.(next ?? "all")} data-tippy-content="Filter by Employee Role">
      <Dropdown.Toggle
        variant={usedTheme.BUTTON_VARIANT}
        id="employee-role-dropdown"
        style={{
          backgroundColor: usedTheme.BACKGROUND_COLOR,
          color: "gray",
          border: "1px solid",
          borderColor: usedTheme.BORDER_COLOR,
          width: "100%",
          height: Spacing.SCALE_38,
          textAlign: "left",
          padding: "8px",
          marginLeft: Spacing.SCALE_2,
          marginTop: Spacing.SCALE_4,
          marginBottom: Spacing.SCALE_4,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {renderLabel(value)}
      </Dropdown.Toggle>
      <Dropdown.Menu style={{ backgroundColor: usedTheme.BACKGROUND_COLOR, borderColor: usedTheme.BORDER_COLOR }}>
        {options.map((role) => (
          <Dropdown.Item
            key={role.value}
            style={{ color: usedTheme.TEXT_COLOR }}
            eventKey={role.value}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = usedTheme.BORDER_COLOR;
              e.target.style.color = usedTheme.TEXT_COLOR;
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "transparent";
              e.target.style.color = usedTheme.TEXT_COLOR;
            }}
          >
            {role.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default EmployeeRoleFilter;

